export enum AuditoriumsRedirectAction {
  AddConfiguration = 'addConfiguration',
  CopyConfiguration = 'copyConfiguration',
  ArchiveConfiguration = 'archiveConfiguration',
  UnarchiveConfiguration = 'unarchiveConfiguration',
}
